(function productInventoryFunction() {
    var selectors = {
      singleOptionSelector: '[data-single-option-selector]',
      originalSelectorId: '[data-product-select]',
      input: '.product-quantity__num',
      inventoryDisplay: '[inventory-display]', // For Jack1t's inventory display
      showInventory: 'data-threshold',
      inventoryDisplayNumber: '[inventory-display-number]',
      inventoryMessage: '.variant-inventory__message',
      inventoryLastOne: '.variant-inventory__last-one',
      progressBar: '.progress-bar__progress'
    };
  
    var $inventoryDisplay = $(selectors.inventoryDisplay);
    var showInventory = $inventoryDisplay.attr(selectors.showInventory);
  
    function inventoryDisplayUpdate(currentInventory) {
      var progress;
  
      if (showInventory > currentInventory) {
        if (currentInventory === 1) {
          $(selectors.inventoryMessage).addClass('hide');
          $(selectors.inventoryLastOne).removeClass('hide');
        } else {
          $(selectors.inventoryMessage).removeClass('hide');
          $(selectors.inventoryLastOne).addClass('hide');
        }
  
        $(selectors.inventoryDisplayNumber).text(currentInventory);
        progress = Math.floor((currentInventory / showInventory) * 100);
        $(selectors.progressBar).css('width', progress + '%');
  
        $inventoryDisplay.slideDown();
      } else {
        $inventoryDisplay.slideUp();
      }
    }
  
    function handleValChange() {
      var $closestForm = $(this).closest('form');
  
      setTimeout(function productInventoryTimeout() {
        var $selectedVariant = $closestForm.find(
          selectors.originalSelectorId + ' option:selected'
        );
  
        var $variantInventory = $selectedVariant.data('max');
  
        if ($selectedVariant.data('max')) {
          $selectedVariant
            .closest('form')
            .find($(selectors.input))
            .attr('max', $variantInventory);
  
          if (
            $selectedVariant
              .closest('form')
              .find($(selectors.input))
              .val() > $variantInventory
          ) {
            console.log('Too many');
            $selectedVariant
              .closest('form')
              .find($(selectors.input))
              .val($variantInventory);
          }
  
          inventoryDisplayUpdate($variantInventory);
        } else {
          $selectedVariant
            .closest('form')
            .find($(selectors.input))
            .removeAttr('max');
  
          $inventoryDisplay.slideUp();
        }
      }, 50);
    }
  
    function _init() {
      $(selectors.singleOptionSelector).on('change', handleValChange);
    }
  
    _init();
  })();